import { type GetStaticPropsContext, type GetStaticPaths } from "next";
import Layout from "~/components/Layout";
import { getCategoriesSlug } from "~/lib/db/category";
import { type LoopPostReturnType } from "~/lib/db/loops";
import {
  getArticleByCategory,
  getPostsMetadata,
  getThumbnail,
} from "~/lib/db/posts";
import {
  getAllSpeciali,
  getNameSpeciali,
  type getNameSubSpecialiType,
  getParentSpeciali,
  getSubSpeciali,
} from "~/lib/db/speciali";
import { type ArticlePreviewType, type ISSUES, ISSUES_TYPE } from "~/types";
import { postExcerpt } from "~/utils";
import Image from "next/image";
import Link from "next/link";
import Share from "~/components/Article/Share";
import Print from "~/components/Article/Print";
import PostContent from "~/components/PostContentComponent";
import { creaHtmlPost, createNote } from "~/utils/postUtils";
import useLoginURL from "@hooks/useLoginURL";
import { useSession } from "next-auth/react";
import textSizeIcon from "@public/icon/text-size.svg";
import { FontSizeContext, fontSizes } from "~/components/FontSizeContext";
import { useCallback, useContext } from "react";
import { filterCategorySpecial, returnUrlTypeCategory } from "~/utils/utils";

const textPreviewRule = {
  backgroundImage:
    "linear-gradient(180deg, rgba(61,68,77,1) 0%, rgba(255,255,255,0) 100%)",
  backgroundClip: "text",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
};
const TotalSpecial = ({
  infSpecial,
  categoryName,
  numberDescription,
  numeroName,
  numeroSlug,
  articles,
  restrictAccess = false,
}) => {
  const session = useSession();
  const numeroDesc =
    numberDescription != null ? numberDescription.split("|") : null;
  const loginURL = useLoginURL();
  const noteForAllArticle = [];
  articles.map((article) => {
    const note = createNote(article);
    noteForAllArticle.push(note != null ? note : []);
  });
  const { fontSize, setFontSize } = useContext(FontSizeContext);

  const rotateFontSizes = useCallback(() => {
    const currentFontIndex = fontSizes.findIndex((sizes) => sizes === fontSize);

    const nextIndex = (currentFontIndex + 1) % fontSizes.length;

    setFontSize(fontSizes[nextIndex] as string);
  }, [fontSize, setFontSize]);

  return (
    <Layout title={categoryName}>
      <section className="-mt-12 w-full pb-20 print:pb-0">
        <div className="mx-auto max-w-section py-16 max-xl:px-4 xl:pb-12 xl:pt-52 print:max-w-none print:px-4 print:pb-0 print:pt-12">
          <div className="mb-12 flex max-lg:flex-wrap-reverse sm:mb-20 sm:text-xl lg:justify-between print:mb-6">
            <div>
              <div className="mb-4 flex flex-col gap-2 text-base sm:mb-9 md:text-[22px] print:mb-4 print:text-lg">
                <Link
                  className="font-bold text-black"
                  key={"speciali"}
                  href={"/speciali"}
                >
                  Speciali
                </Link>
              </div>
              <div className="mt-5 flex justify-between">
                <span className="text-lg uppercase md:text-2xl print:text-lg">
                  {numeroSlug != null && (
                    <>
                      <Link
                        className="font-bold text-orange"
                        href={`/n/${numeroSlug.replace()}`}
                      >
                        BS {numeroName}
                      </Link>
                      <span className="font-light">
                        {" "}
                        /
                        {`${numeroDesc[1]
                          ?.replace("/", " ")
                          ?.toUpperCase()} ${numeroDesc[0]?.toUpperCase()}`}
                      </span>
                    </>
                  )}
                </span>
              </div>
            </div>
            {session?.status == "authenticated" && (
              <div className="flex items-center justify-end gap-6 max-lg:mb-12 max-lg:w-full md:gap-10  print:hidden">
                <Share title={infSpecial.name.replace(/<\/?[^>]+(>|$)/g, "")} />
                <Print />
              </div>
            )}
          </div>
          <Link href={`/s/${infSpecial.slug}`}>
            <h1
              className="my-10 text-3xl font-thin transition-all hover:opacity-80 md:text-5xl lg:text-6xl print:text-4xl"
              dangerouslySetInnerHTML={{ __html: infSpecial.name }}
            ></h1>
          </Link>

          <div className="mb-8 xl:mb-28 print:mb-10">
            {infSpecial.img != null && (
              <figure className="inline rounded-3xl bg-lightLightGray">
                <Image
                  src={infSpecial.img}
                  width={1200}
                  height={790}
                  className="rounded-3xl object-cover mix-blend-multiply print:block print:w-1/3"
                  alt={infSpecial?.img || "immagine di copertina"}
                />
              </figure>
            )}
          </div>
          <button
            onClick={rotateFontSizes}
            className="flex items-center gap-2.5 transition-all hover:cursor-pointer hover:opacity-75 print:hidden"
          >
            <Image
              width={28}
              height={28}
              src={textSizeIcon}
              alt="Dimensione testo"
            />
            <span className="text-lg font-light italic">
              dimensione del testo
            </span>
          </button>
        </div>

        {restrictAccess ? (
          <div className="relative top-[-150px] flex w-full justify-center bg-gradient-to-t from-white from-40% py-40">
            <div className="mx-6 flex w-full max-w-2xl flex-col justify-center border p-6">
              <h4 className="pb-6 text-center text-lg font-bold">
                Contenuto riservato agli abbonati
              </h4>
              <div className="flex flex-col items-stretch justify-center md:flex-row md:items-center">
                {session?.status !== "authenticated" && (
                  <a
                    className=" btn m-2 flex-1 rounded-lg bg-lightBlue px-6 py-2 text-center text-white"
                    href={loginURL}
                  >
                    Accedi
                  </a>
                )}
                <a
                  className=" btn m-2 flex-1 rounded-lg bg-magenta px-6 py-2 text-center text-white"
                  href="https://servizi.sgi-italia.org/abbonamenti/index.php/site/abbonamenti"
                >
                  Sottoscrivi un abbonamento
                </a>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="mx-auto max-w-section">
              <div className="mb-28 max-xl:px-4">
                <ul
                  className="list-disc pl-5 font-semibold"
                  style={{ fontSize }}
                >
                  {articles.map(({ post_name, post_title }) => (
                    <>
                      <li key={post_name}>
                        <Link href={`#${post_name}`}>{post_title}</Link>
                      </li>
                    </>
                  ))}
                </ul>
              </div>
              {articles.map((article, index) => (
                <div
                  key={article.post_name}
                  id={article.post_name}
                  className="mb-28"
                >
                  {article.meta &&
                    filterCategorySpecial(article.meta, "speciale") != null && (
                      <div className="mb-6 mt-10 max-xl:px-4">
                        {filterCategorySpecial(article.meta, "speciale").map(
                          (category, index) => (
                            <>
                              <Link
                                key={index}
                                className="text-base font-bold uppercase text-orange hover:underline"
                                href={returnUrlTypeCategory(
                                  category.slug,
                                  category.taxonomy as ISSUES
                                )}
                              >
                                {`${category.name}`}
                              </Link>
                              {index <
                                filterCategorySpecial(article.meta, "speciale")
                                  .length -
                                  1 && (
                                <span className="entry-cat font-bold text-orange lg:text-5xl print:my-2 print:text-4xl">
                                  ,{" "}
                                </span>
                              )}
                            </>
                          )
                        )}
                      </div>
                    )}
                  <Link href={`/a/${article.post_name}`}>
                    <h1
                      className="mb-10 text-3xl transition-all hover:opacity-80 max-xl:px-4 lg:text-5xl"
                      dangerouslySetInnerHTML={{ __html: article.post_title }}
                    ></h1>
                  </Link>

                  <PostContent
                    htmlContent={creaHtmlPost(
                      article.post_content,
                      noteForAllArticle[index],
                      `/s/${infSpecial.slug}/all`
                    )}
                    polls={[]}
                    textStyle={restrictAccess && textPreviewRule}
                    indexArticle={index}
                  />
                  {noteForAllArticle[index].length > 0 && (
                    <div className="mx-auto my-8 max-w-section max-xl:px-4">
                      <span className="font-medium">NOTE</span>
                      <ol key={noteForAllArticle[index]}>
                        {noteForAllArticle[index].map((nota, index) => (
                          <li className="py-1" key={nota.id} id={nota.id}>
                            <Link
                              href={`/s/${infSpecial.slug}/all/#${nota.id}-link`}
                              dangerouslySetInnerHTML={{
                                __html: `${index + 1}. `,
                              }}
                            ></Link>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: `${nota.content}`,
                              }}
                            ></span>
                          </li>
                        ))}
                      </ol>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        )}
        <div className="mx-auto hidden max-w-section px-4 pt-12 print:block print:px-4 print:pt-0">
          <p className="py-6 text-sm text-gray print:text-base">
            <strong>©buddismoesocieta.org</strong> – diritti riservati,
            riproduzione&nbsp;riservata
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default TotalSpecial;

export const getStaticPaths: GetStaticPaths<{
  speciali: string;
}> = async () => {
  const specialiSlug = await getCategoriesSlug(ISSUES_TYPE.speciali);

  return {
    paths: specialiSlug.map((speciali) => ({
      params: { speciali: speciali.slug },
    })), //indicates that no page needs be created at build time
    fallback: "blocking", //indicates the type of fallback
  };
};

export const getStaticProps = async ({ params }: GetStaticPropsContext) => {
  if (!params || params.speciali == "speciali") return { notFound: true };
  const allSpeciali = (await getAllSpeciali()).filter(
    (speciali) => speciali.slug == params.speciali
  )[0];
  try {
    const speciali = await getNameSpeciali(allSpeciali.slug as string);
    if (!speciali) return { notFound: true };
    const [parent, subCategory, articleByCategory] = await Promise.all([
      getParentSpeciali(speciali.parent),
      getSubSpeciali(speciali.term_id),
      getArticleByCategory(speciali.term_id),
    ]);

    const articlesId = articleByCategory.map((el) => el.ID);

    const [metaData, thumbnail] = await Promise.all([
      articlesId.length > 0
        ? getPostsMetadata(articlesId)
        : Promise.resolve([]),
      articlesId.length > 0 ? getThumbnail(articlesId) : Promise.resolve([]),
    ]);

    const mapPostsForClient = (
      posts: LoopPostReturnType[]
    ): ArticlePreviewType[] =>
      posts.map(
        ({
          ID,
          post_title,
          post_name,
          post_excerpt,
          post_content,
          post_date,
        }) => ({
          post_name,
          post_title,
          post_content,
          post_excerpt:
            post_excerpt != ""
              ? postExcerpt(post_excerpt)
              : postExcerpt(
                  post_content
                    ?.replace(/<\/?[^>]+(>|$)/g, "")
                    ?.replace(/\[\/{0,1}et_pb_.*\]/g, "")
                ),
          meta: metaData[Number(ID)] != null ? metaData[Number(ID)] : null,
          thumbnail:
            thumbnail[Number(ID)]?.thumbnail != null
              ? thumbnail[Number(ID)]?.thumbnail
              : null,
          alt:
            thumbnail[Number(ID)]?.alt != null
              ? thumbnail[Number(ID)]?.alt
              : null,
          post_date: post_date.toISOString(),
        })
      );

    const mapSpecialiForClient = (
      posts: getNameSubSpecialiType[]
    ): getNameSubSpecialiType[] =>
      posts.map(({ slug, name, description }) => ({
        slug,
        name,
        description: description != undefined ? description : null,
      }));

    return {
      props: {
        infSpecial: allSpeciali,
        categoryName: allSpeciali.name,
        category_slug: params.speciali,
        numeroSlug:
          allSpeciali.numeroSlug != null ? allSpeciali.numeroSlug : null,
        numeroName:
          allSpeciali.numeroName != null ? allSpeciali.numeroName : null,
        numberDescription:
          allSpeciali.numberDescription != null
            ? allSpeciali.numberDescription
            : null,
        parent_category_slug: parent?.slug || params.speciali,
        parent_category_name:
          parent?.name.replace("&amp;", " & ") ||
          speciali.name.replace("&amp;", " & "),
        subCategory: mapSpecialiForClient(subCategory),
        articles: mapPostsForClient(articleByCategory),
      },
      revalidate: 20 * 60,
    };
  } catch (error) {
    console.log("Error fetching static props for", params.speciali, error);
    return { notFound: true };
  }
};
